import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWallet } from "@fortawesome/free-solid-svg-icons";
import FormattedAmount from "components/shared/FormattedAmount";
import { LANGUAGE, CURRENCY_TEXT } from "services/general";

/**
 * MoreToolsWalletCard — wallet balance shortcut shown in the phone drawer
 * when the user has wallet access.
 */
const MoreToolsWalletCard = ({
  isDark,
  balance,
  currency,
  currencyIconUrl,
  onNavigate,
}) => {
  const { t } = useTranslation();

  return (
    <Link
      to={`/${LANGUAGE}/wallet`}
      onClick={onNavigate}
      className={`p-4 rounded-2xl flex items-center justify-between border transition-all ${
        isDark
          ? "bg-chrome bg-gradient-to-r from-brand/[0.15] to-transparent border-white/[0.12] text-white"
          : "bg-surface bg-gradient-to-r from-brand/[0.08] to-brand/[0.15] border-brand/30 text-primary"
      }`}
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-primary text-white flex items-center justify-center shrink-0">
          <FontAwesomeIcon icon={faWallet} className="text-base" />
        </div>
        <div>
          <div className="text-xs opacity-75">
            {t("wallet.pageTitle") || "رصيد المحفظة"}
          </div>
          <div className="text-base font-bold nums-font">
            <FormattedAmount
              value={balance ?? 0}
              suffix={
                currencyIconUrl ? (
                  <img
                    src={currencyIconUrl}
                    alt={currency?.code ?? ""}
                    className="inline-block w-[1.17em] h-[1.17em] ms-1 align-middle"
                  />
                ) : (
                  CURRENCY_TEXT
                )
              }
            />
          </div>
        </div>
      </div>
      <span className="text-xs font-semibold px-2.5 py-1 rounded-lg bg-primary text-white shrink-0">
        {t("view") || "عرض"}
      </span>
    </Link>
  );
};

export default MoreToolsWalletCard;
